import { ResponseMESF } from "@dexteel/mesf-core";
import { Box, Paper } from "@mui/material";
import { AgGridReact } from "ag-grid-react";
import { useState } from "react";
import { AgGridFooterActions } from "../../../../../../shared/data-entries/AgGridFooterActions";
import { useDataEntryContext } from "../../../context/reducer.provider";
import { useTimerContext } from "../../../context/timer.provider";
import { useCasterDataEntryActions } from "../../../hooks/useCasterDataEntryActions";
import { readProbesFromPLC } from "../../../repositories/caster.repositories";
import { ProbeModal } from "../../modals/probe/ProbeModal";
import { useTheme } from "@mui/material/styles";
import { dataEntryTableStyles } from "../../../../../../shared/styles/dataEntryTableStyles";
import { useTableData } from "./hooks/useProbesTableData";
import { CenteredLazyLoading } from "@/controls/LazyLoading";
import { defaultColDef, defaultGridOptions } from "@/setup/ag-grid/mesf-theme";

export const TableProbes = () => {
  const theme = useTheme();
  const styles = dataEntryTableStyles(theme);

  const { pause, resume } = useTimerContext();
  const {
    state: { deProcess },
    actions: { setNotificationMessage, setErrorMessage },
  } = useDataEntryContext();
  const { refreshData, deleteProbe } = useCasterDataEntryActions();

  const probes = deProcess?.probes;

  const [selectedProbe, setSelectedProbe] = useState<any>();
  const [showModal, setShowModal] = useState<"NEW" | "EDIT" | "">("");

  const readAutomaticProbes = async (value?: string) => {
    if (value === "OK") {
      const resp = await readProbesFromPLC({
        ProcessId: deProcess!.process!.ProcessId,
      });
      if (resp.ok) {
        setNotificationMessage("Read probes from PLC successful");
        await refreshData();
        return resp as ResponseMESF;
      } else {
        setErrorMessage(resp.message);
        return {
          ok: false,
          message: "Read probes from PLC failed",
        } as ResponseMESF;
      }
    } else {
      return {} as ResponseMESF;
    }
  };

  const editProbe = (ProbeId: number) => {
    pause();
    const probe = probes?.find((p) => p.ProbeId === ProbeId);
    setSelectedProbe(probe);
    setShowModal("EDIT");
  };

  const { columns } = useTableData({
    deleteProbe,
    editProbe,
  });

  return (
    <Paper>
      <Box padding={1} sx={styles.agGridBox}>
        <AgGridReact
          rowData={probes}
          columnDefs={columns}
          defaultColDef={{ ...defaultColDef, sortable: false }}
          loadingOverlayComponent={CenteredLazyLoading}
          {...defaultGridOptions}
        />
        <AgGridFooterActions
          setShowModal={setShowModal}
          readFromPLC={readAutomaticProbes}
          table="probes"
          pause={pause}
        />
      </Box>
      <ProbeModal
        showModal={showModal}
        probe={selectedProbe}
        onHide={() => {
          resume();
          setShowModal("");
        }}
      />
    </Paper>
  );
};
